/* eslint-disable @typescript-eslint/member-ordering */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form as FinalForm } from 'react-final-form';
import { Form, Button } from 'semantic-ui-react';
import arrayMutators from 'final-form-arrays';

import StepProgress, { Step } from 'components/StepProgress';
// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';
import { SprayEventWizardStep } from 'services/sprayEventWizard/types';
import { makeSelectSprayEventWizardStep } from 'services/sprayEventWizard/selectors';
import { AppState } from 'services/types';
import { setSprayEventWizardStep } from 'services/sprayEventWizard/actions';
import { SPRAY_EVENT_WIZARD_SCHEDULE_STEP } from 'services/sprayEventWizard/constants';

interface OwnProps {
    onSubmit: Function;
    steps?: Step[];
    classname?: string;
    initialValues?: Record<string, any>;
    children: React.ReactNode;
    namespace: string;
    setLastSubmittedAt?: Function;
}

interface ConnectedProps {
    step: SprayEventWizardStep;
}

interface DispatchProps {
    setSprayEventWizardStep: typeof setSprayEventWizardStep;
}

interface State {
    values: Record<string, any>;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class WizardComponent extends React.Component<Props, State> {
    static Page = ({ children }: any): any => children;

    myRef: React.RefObject<any>;

    constructor(props: Props) {
        super(props);

        this.myRef = React.createRef();

        this.state = {
            values: props.initialValues || {}
        };
    }

    componentWillUnmount(): void {
        this.setSelectedStep(SPRAY_EVENT_WIZARD_SCHEDULE_STEP);
    }

    setSelectedStep = (step: SprayEventWizardStep, isValid = true): void => {
        const { props } = this;

        isValid && props.setSprayEventWizardStep(step);
    };

    handleNext = (values: Record<string, any>): void => {
        const { children, step } = this.props;

        this.setState((state: any) => ({
            values
        }));

        // @ts-ignore
        this.setSelectedStep(Math.min(step + 1, children.length - 1));
    };

    handlePrevious = (): void => {
        const { step } = this.props;

        // @ts-ignore
        this.setSelectedStep(Math.max(step - 1, 0));

        const modal = document.getElementsByClassName('modal fullscreen')[0];

        if (modal) {
            // Fullscreen modal can get quite long heigh, so we scroll back to the top
            modal.scrollIntoView();
        } else {
            this.myRef.current.scrollIntoView();
        }
    };

    handleSubmit = (values: any): void => {
        const { children, onSubmit, step } = this.props;
        const isLastPage = step === React.Children.count(children) - 1;

        const modal = document.getElementsByClassName('modal fullscreen')[0];

        if (isLastPage) {
            onSubmit(values);
        } else {
            if (modal) {
                // Fullscreen modal can get quite long heigh, so we scroll back to the top
                modal.scrollIntoView();
            } else {
                this.myRef.current.scrollIntoView();
            }

            this.handleNext(values);
        }
    };

    render(): React.ReactElement {
        const {
            children,
            steps,
            classname,
            step,
            namespace,
            setLastSubmittedAt
        } = this.props;
        const { values } = this.state;
        const activePage = React.Children.toArray(children)[step];
        const isLastPage = step === React.Children.count(children) - 1;

        return (
            <section className={classname} ref={this.myRef}>
                <FinalForm
                    initialValues={values}
                    onSubmit={this.handleSubmit}
                    mutators={{ ...arrayMutators }}
                >
                    {(props): React.ReactElement => {
                        const { handleSubmit, submitting, invalid } = props;

                        const onSubmit = (formValues: any) => {
                            handleSubmit(formValues);
                            if (setLastSubmittedAt) {
                                setLastSubmittedAt(new Date());
                            }
                        };

                        return (
                            <Form onSubmit={onSubmit}>
                                {steps && steps.length > 0 && (
                                    <StepProgress
                                        steps={steps}
                                        setSelectedStep={(
                                            value: SprayEventWizardStep
                                        ): void => {
                                            this.setSelectedStep(
                                                value,
                                                !invalid
                                            );
                                        }}
                                        selectedStep={step}
                                    />
                                )}
                                {activePage}
                                <div className="footer-buttons || buttons">
                                    {step > 0 && (
                                        <Button
                                            basic
                                            primary
                                            type="button"
                                            onClick={this.handlePrevious}
                                        >
                                            Previous
                                        </Button>
                                    )}
                                    {!isLastPage && (
                                        <Button primary type="submit">
                                            Next
                                        </Button>
                                    )}
                                    {isLastPage && (
                                        <SubmittingButton
                                            primary
                                            type="submit"
                                            disabled={submitting}
                                            namespace={namespace}
                                        >
                                            Submit
                                        </SubmittingButton>
                                    )}
                                </div>
                            </Form>
                        );
                    }}
                </FinalForm>
            </section>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    step: makeSelectSprayEventWizardStep()
});

export default connect(mapStateToProps, {
    setSprayEventWizardStep
})(WizardComponent);
